import { Component, Inject, OnInit } from '@angular/core';
import { Config, OccConfig, Product } from '@spartacus/core';
import { CurrentProductService } from '@spartacus/storefront';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { distinctUntilChanged, filter, map, tap } from 'rxjs/operators';

@Component({
    selector: 'app-uig-product-downloads-tab',
    templateUrl: './uig-product-downloads-tab.component.html',
    styleUrls: ['./uig-product-downloads-tab.component.scss'],
    standalone: false
})
export class UigProductDownloadsTabComponent implements OnInit {

  detailsMediaContainer = new BehaviorSubject(null);
  galleryMediaContainer = new BehaviorSubject(null);

  product$: Observable<Product> = this.currentProductService
    .getProduct()
    .pipe(
      filter(Boolean),
      distinctUntilChanged(),
      tap((p: Product) => {
        this.detailsMediaContainer.next(p.images?.DETAILS ? p.images.DETAILS : {});
        this.galleryMediaContainer.next(p.images?.GALLERY ? p.images.GALLERY : {});
      })
    );

  detailsThumbs$: Observable<any[]> = this.product$.pipe(
    map((p: Product) => this.createDetailsThumbs(p))
  );

  galleryThumbs$: Observable<any[]> = this.product$.pipe(
    map((p: Product) => this.createGalleryThumbs(p))
  );

  constructor(protected currentProductService: CurrentProductService, @Inject(Config) protected config: Config) { }

  ngOnInit(): void {
    this.product$ = this.currentProductService.getProduct();
  }

  goToLink(url: string){
    window.open(url, "_blank");
  }

  private createDetailsThumbs(product: Product): Observable<any>[] {
    if (
      !product.images ||
      !product.images.DETAILS ||
      (Array.isArray(product.images.DETAILS) &&
      product.images.DETAILS.length < 1)
    ) {
      return null;
    }
    return (<any[]>product.images.DETAILS).map((c) => of({ container: c }));
  }

  private createGalleryThumbs(product: Product): Observable<any>[] {
    if (
      !product.images ||
      !product.images.GALLERY ||
      (Array.isArray(product.images.GALLERY) &&
        product.images.GALLERY.length < 1)
    ) {
      return null;
    }
    return (<any[]>product.images.GALLERY).map((c) => of({ container: c }));
  }

  resolveAbsoluteUrl(url: string): string {
    return !url || url.startsWith('http') || url.startsWith('//')
      ? url
      : this.getBaseUrl() + url;
  }

  protected getBaseUrl(): string {
    return (
      (this.config as OccConfig).backend?.media?.baseUrl ??
      (this.config as OccConfig).backend?.occ?.baseUrl ??
      ''
    );
  }

}
